import React from 'react';
import Icon, {IconSize} from '../../../ui/Icon/Icon';
import {GenericIconName} from '../../../ui/Icon/IconName';
import {ErrorIconWrapper, ModalText, ModalTitle} from '../ProductReview.styled';
import {useProductReviewTranslations} from '../context/ProductReviewTranslationsProvider';

const AlreadyVotedMesssage: React.FC = () => {
  const {alreadyVotedTitle, alreadyVotedDescription} =
    useProductReviewTranslations();
  return (
    <>
      <ErrorIconWrapper>
        <Icon asset={GenericIconName.IcCross} size={IconSize.M} />
      </ErrorIconWrapper>
      <ModalTitle data-testid="review-modalTitle-voted">
        {alreadyVotedTitle}
      </ModalTitle>
      <ModalText data-testid="review-modalDesc-voted">
        {alreadyVotedDescription}
      </ModalText>
    </>
  );
};

export default AlreadyVotedMesssage;
